import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import DocumentsSection from '../components/home/DocumentsSection';
import PricingSection from '../components/home/PricingSection';
import CTASection from '../components/home/CTASection';

export default function DocumentsPage() {
  const { t } = useLanguage();

  return (
    <>
      <div className="page-hero">
        <div className="container">
          <h1>{t.documents.title}</h1>
          <p>{t.documents.subtitle}</p>
        </div>
      </div>
      <DocumentsSection showAll />
      <PricingSection />
      <CTASection />
    </>
  );
}
